import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

const Container = styled('div')`
  ${tw`mb-4 relative`}
  &:last-child {
    margin-bottom: 0;
  }
`;

const FloatingContainer = styled(Container)`
  > input, textarea {
    padding-top: 1.5rem;
  }
  
  label {
    pointer-events: none;
  }
    
  > input[value=""] + label,
  > input:not([value]) + label {
    top: 50%;
    transform: translate3d(0, -50%, 0) scale(1);
  }
  
  > textarea[value=""] + label,
  > textarea:not([value]) + label {
    top: 0;
    transform: translate3d(0, 50%, 0) scale(1); 
  }
  
  > label,
  > input:focus + label,
  > textarea:focus + label {
    position: absolute;
    top: 0.5rem;
    left: 0.75rem;
    transform: translate3d(0, 0, 0) scale(0.7);
    transition: 0.2s transform;
    transform-origin: left;
  }

`;

const FormGroup = ({ label, input, style, className }) => {
  return (
    style === 'floating'
      ? <FloatingContainer>
        {input}
        {label}
      </FloatingContainer>
      : <Container className={className}>
        {label}
        {input}
      </Container>
  );
};

FormGroup.propTypes = {
  label: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  style: PropTypes.oneOf(['normal', 'floating']),
};

FormGroup.defaultProps = {
  style: 'normal',
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/Form/FormGroup.js